<template>
  <div class="d-block align-items-center d-lg-flex">
    <div class="feeds-heading text-big bold mr-3" v-if="heading">{{ heading }}</div>
    <tabs
      tab-class="text-small-1"
      class="mx-lg-0 mx-n2 mt-1"
      :show-slider="false"
      :items="options"
      :selected-index="selectedIndex"
      @change="onFilter(options[$event])"
    />
  </div>
</template>

<script>
import Tabs from '@/components/Tabs.vue'
import { FEED_FILTER_PREFERENCES } from '@/constants/activity'

/**
 * This component renders the Heading for activity(Discussion) section.
 * Along with heading it also shows filter dropdown with below options
 *  - Show only comment
 *  - Show with audit log
 *
 * Props:
 *  - heading
 *
 * @emits
 * - filter: emitted when filter preference is changed
 */
export default {
  name: 'FeedsHeading',
  props: ['heading', 'entityType', 'selectedFilter'],
  components: {
    Tabs
  },
  data() {
    return {
      options: FEED_FILTER_PREFERENCES
    }
  },
  computed: {
    selectedIndex() {
      return this.options.findIndex(option => option.id === this.selectedFilter?.id)
    }
  },
  methods: {
    onFilter(selected) {
      this.$emit('filter', selected)
      this.$store.commit('feedPreference/SET_SELECTED_FILTER', {
        entityType: this.entityType,
        filter: selected
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
